import AppTabs from 'general/components/AppTabs';
import AppColors from 'general/constants/AppColors';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import NotificationConfigTabView from '../../components/NotificationConfigTabView';
import SystemNotificationTabView from '../../components/SystemNotificationTabView';

PushNotificationListScreen.propTypes = {
  agencyId: PropTypes.string,
};

function PushNotificationListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const { agencyId } = props;
  const { t } = useTranslation();
  const router = useRouter();

  const tabs = useMemo(() => {
    return [
      'Thông báo thủ công',
      'Thông báo hệ thống',
    ].reverse()
  }, []);
  const [selectedTab, setSelectedTab] = useState(t('Thông báo thủ công'));
  const hash = router?.location?.hash;
  useEffect(() => {
    if (hash === '#notification-config') setSelectedTab('Thông báo thủ công');
    if (hash === '#system-notification') setSelectedTab(t('Thông báo hệ thống'));
  }, [hash]);

  const notificationConfigTabView = useMemo(() => {
    return (
      <NotificationConfigTabView />
    );
  }, []);

  const systemNotificationTabView = useMemo(() => {
    return (
      <SystemNotificationTabView />
    );
  }, []);

  // MARK: ---- METHODS ----

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    if (newTab === 'Thông báo thủ công') {
      router.navigate('#notification-config');
    }
    if (newTab === 'Thông báo hệ thống') {
      router.navigate('#system-notification');
    }
    setSelectedTab(newTab);
  };

  return (
    <div className='px-4'>
      <div className="pt-0">
        <AppTabs
          tabs={tabs}
          activeTab={selectedTab}
          handleClick={handleSelectedTab}
          className="mt-3 mr-3"
          additionalClassName=""
        />
        <div
          className="bg-white shadow"
          style={{
            borderLeft: `1px solid ${AppColors.gray[300]}`,
            borderRight: `1px solid ${AppColors.gray[300]}`,
            borderBottom: `1px solid ${AppColors.gray[300]}`,
            borderRadius: '0px 10px 10px 10px',
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={selectedTab}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              {selectedTab == 'Thông báo thủ công' && (
                <div className="py-4">{notificationConfigTabView}</div>
              )}
              {selectedTab == 'Thông báo hệ thống' && (
                <div className="pb-3 pt-4">{systemNotificationTabView}</div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default PushNotificationListScreen;
